import type { GridKey } from '../api/types'

export interface Coverage {
  /** Keys translated on this project. */
  own: number
  /** Keys with no own translation that resolve to the default project's wording. */
  fallback: number
  /** Keys with nothing to serve in this locale. */
  missing: number
  total: number
  /** Share of keys that resolve to a value at all (own + inherited). */
  pct: number
}

/** Per-locale coverage of the loaded grid. Computed client-side from the grid
 *  the translator already has, so the editor can show progress for the current
 *  project (including client fallbacks) without a second request. */
export function coverageByLocale(
  keys: GridKey[],
  codes: string[],
): Record<string, Coverage> {
  const out: Record<string, Coverage> = {}
  for (const code of codes) {
    let own = 0
    let fallback = 0
    let missing = 0
    for (const key of keys) {
      const cells = key.cells[code] ?? []
      const resolved = cells.filter((cell) => cell.origin !== 'untranslated' && cell.value)
      // A plural key only counts as done when every CLDR form resolves.
      if (cells.length === 0 || resolved.length < cells.length) missing += 1
      else if (resolved.every((cell) => cell.origin === 'fallback')) fallback += 1
      else own += 1
    }
    const total = keys.length
    out[code] = {
      own,
      fallback,
      missing,
      total,
      pct: total === 0 ? 0 : Math.round(((own + fallback) / total) * 100),
    }
  }
  return out
}
